import { darkGrey } from "reports/constants/colors";
import {
  FONT_SIZE_EXTRA_SMALL,
  FONT_SIZE_SMALL,
} from "reports/constants/constants";

/**
 * Renders a custom date tick
 * @param x horizontal positiom
 * @param y vertical position
 * @param textAnchor text align
 * @param value text content
 */
export const customDateTick =
  (isPrint = false) =>
  ({ x, y, textAnchor, payload }) => {
    return (
      <text
        key={Math.random() * 1000}
        x={x}
        y={y + 10}
        textAnchor={textAnchor}
        fill={darkGrey}
        fontSize={isPrint ? FONT_SIZE_SMALL : FONT_SIZE_EXTRA_SMALL}
      >
        {payload.value}
      </text>
    );
  };
